import { layoutOf } from '../../domain/layout';
import { singleAxle } from '../wheel-placements';
import { WHEEL_LOADER } from './dimensions';

const WHEEL_LOADER_LAYOUT = layoutOf(['single', 'single']);
const WHEEL_LOADER_WHEELS = WHEEL_LOADER.axles.flatMap((axle, index) => singleAxle({
  axle: index + 1,
  x: axle.x,
  radius: WHEEL_LOADER.wheelRadius,
  width: WHEEL_LOADER.tyreWidth,
  halfTrack: axle.halfTrack,
  style: 'steel',
}));

export {
  WHEEL_LOADER_LAYOUT,
  WHEEL_LOADER_WHEELS,
};
